import type { FilterFieldConfig } from 'components/common/MasterFilter';

const clientsBarConfig: FilterFieldConfig[] = [
  {
    key: 'searchTerm',
    kind: 'text',
    label: 'Buscar',
    placement: 'bar',
    placeholder: 'ID, Nombre, teléfono, email o RUT',
  },
  { key: 'dateRange', kind: 'dateRange', label: 'Fecha', placement: 'bar' },
  { key: 'sources', kind: 'multiSelect', label: 'Origen', placement: 'bar' },
  { key: 'topics', kind: 'multiSelect', label: 'Tags', placement: 'bar' },
];

export default clientsBarConfig;
